module.exports = __webpack_public_path__ + "static/media/alberta-amazing-attraction-banff-417074.7d2d0483.jpg";